import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './ExchangeMarketFluctuationInput.scss';

import { moduleActions } from '../../../redux/modules';
import {
  getAcceptedMarketFluctuationDisclosure,
  getExchangeFromUnit,
} from '../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import Checkbox from '../../Shared/Checkbox/Checkbox';

function ExchangeMarketFluctuationInput({
  acceptedMarketFluctuationDisclosure,
  actions: { acceptMarketFluctuationDisclosure },
  exchangeFromUnit,
}) {
  return (
    <Fragment>
      <div className="exchange-market-fluctuation-input-message">
        The requested exchange in {exchangeFromUnit}, may result in an over
        contribution to your IRA due to market fluctuation.
        {` `}
        You may either click "Agree" to continue with the exchange in{' '}
        {exchangeFromUnit} or change the exchange amount to DOLLARS.
      </div>
      <label className="exchange-market-fluctuation-input">
        <Checkbox
          ariaLabel={
            'By checking this box, I certify that I have read the IRA over-contribution warning message.'
          }
          checked={acceptedMarketFluctuationDisclosure}
          id={`market-fluctuation-msg`}
          inline
          onClick={(checked) => acceptMarketFluctuationDisclosure(checked)}
        />
        By checking this box, I certify that I have read the IRA
        over-contribution warning message.
      </label>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    acceptedMarketFluctuationDisclosure:
      getAcceptedMarketFluctuationDisclosure(state),
    exchangeFromUnit: getExchangeFromUnit(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ExchangeMarketFluctuationInput
);
